import { ENDPOINT } from './config'
import { 
    LOGIN_URL, 
    REGISTER_URL, 
    GET_AUDITS_PROGRESS_URL,
    GET_AUDIT_DETAIL_URL,
    CREATE_AUDIT_URL,
    UPDATE_AUDIT_URL
} from './config'
import axios from 'axios'

const Login = async (data) => {
    const resp = await axios.post(LOGIN_URL, data)
    return resp
}

const Register = async (data) => {
    const resp = await axios.post(REGISTER_URL, data)
    return resp
}

const getAuditProgress = async (data) => {
    const resp = await axios.get(GET_AUDITS_PROGRESS_URL, data)
}

const getAuditDetail = async (data) => {
    const resp = await axios.get(GET_AUDIT_DETAIL_URL, data)
}

const getAuditDetailAllVersion = async (data) => {
    const resp = await axios.get()
}

const createAudit = async (data) => {
    const resp = await axios.post(CREATE_AUDIT_URL, data)
    return resp
}

const updateAuditDetail = async (data) => {
    const resp = await axios.post(UPDATE_AUDIT_URL, data)
}

export {
    Login,
    Register,
    getAuditProgress,
    getAuditDetail,
    updateAuditDetail,
    createAudit
}